<mat-form-field [appearance]="appearance">
    <mat-label>{{
        translateFieldLabel ? (getLabelValue() | translate) : getLabelValue()
    }}</mat-label>
    <mat-select
        #matSelect
        [multiple]="multiple"
        [disabled]="disabled"
        [value]="value"
        [class.hide-arrow]="hasValue()"
        (selectionChange)="selectionChange($event.value)"
    >
        <ng-container *ngIf="showSearch$ | async">
            <div class="search-input flex h-12 items-center">
                <mat-icon class="px-4" svgIcon="search"></mat-icon>
                <input
                    matInput
                    type="text"
                    class="caret-primary"
                    (keydown)="$event.stopPropagation()"
                    (input)="searchValue$.next($event.target.value)"
                />
            </div>
            <mat-divider></mat-divider>
        </ng-container>

        <ng-container *ngFor="let optionGroup of optionGroupsFiltered$ | async">
            <ng-container *ngIf="optionGroup.group; else optionsWithoutGroup">
                <mat-optgroup [label]="optionGroup.group" class="opt-group">
                    <ng-container
                        *ngTemplateOutlet="
                            optionsTemplate;
                            context: { options: optionGroup.options }
                        "
                    ></ng-container>
                </mat-optgroup>
            </ng-container>

            <ng-template #optionsWithoutGroup
                ><ng-container
                    *ngTemplateOutlet="
                        optionsTemplate;
                        context: { options: optionGroup.options }
                    "
                ></ng-container
            ></ng-template>

            <ng-template #optionsTemplate let-options="options">
                <mat-option
                    *ngFor="let option of options"
                    [value]="option.value"
                    [disabled]="disabledValues.includes(option.value)"
                    [attr.data-qa]="
                        'dropdown_item_' +
                        option.value?.toString()?.toLowerCase()
                    "
                    >{{
                        translateOptionLabels
                            ? (option.label | translate)
                            : option.label
                    }}</mat-option
                >
            </ng-template>

            <mat-option
                disabled
                *ngIf="loading"
                aria-label="loading"
                class="loading-option"
            >
                <app-loading-bar></app-loading-bar>
            </mat-option>
        </ng-container>
    </mat-select>
    <app-button
        *ngIf="hasValue()"
        [disabled]="disabled"
        iconButton
        matIconSuffix
        icon="close"
        aria-label="Clear"
        data-qa="dropdown_clear-button"
        (mousedown)="clearSelect(); $event.preventDefault()"
    >
    </app-button>
</mat-form-field>
